/* eslint-disable @typescript-eslint/no-unused-vars */
import sendFetch from 'common/utils/fetch';
import { useEffect, useState } from 'react';
import { FullItem } from '../pages/OrderProductSettings';
import { AttachedPhoto } from '../types/OrderServiceItem';
import { CompletionDataProps } from '../types/CompletionDataProps';

export type ParamCardProps = {
  id: string | number;
  name: string;
};

const mockList = [
  {
    id: 'a1',
    name: 'Місто видачі',
  },
  {
    id: 'a2',
    name: 'Місто видачі',
  },
  {
    id: 'a3',
    name: 'Місто видачі',
  },
  {
    id: 'a4',
    name: 'Місто видачі',
  },
  {
    id: 'a5',
    name: 'Місто видачі',
  },
  {
    id: 'a6',
    name: 'Місто видачі',
  },
  {
    id: 'a7',
    name: 'Місто видачі',
  },
  {
    id: 'a8',
    name: 'Місто видачі',
  },
  {
    id: 'a9',
    name: 'Місто видачі',
  },
  {
    id: 'a10',
    name: 'Місто видачі',
  },
  {
    id: 'a11',
    name: 'Місто видачі',
  },
  {
    id: 'a12',
    name: 'Місто видачі',
  },
  {
    id: 'a13',
    name: 'Місто видачі',
  },
  {
    id: 'a14',
    name: 'Місто видачі',
  },
  {
    id: 'a15',
    name: 'Місто видачі',
  },
  {
    id: 'a16',
    name: 'Місто видачі',
  },
  {
    id: 'a17',
    name: 'Місто видачі',
  },
  {
    id: 'a18',
    name: 'Місто видачі',
  },
  {
    id: 'a19',
    name: 'Місто видачі',
  },
];

export const useFetchLocationParams = (searchValue: string, item?: CompletionDataProps) => {
  const [locationList, setItemList] = useState([] as ParamCardProps[]);
  const [searchedList, setSearchedList] = useState([] as ParamCardProps[]);
  const fetchLink = 'https://api-workspace.astin.net/api/get-nomenclature/get-departments';
  useEffect(() => {
    
    const fetchParams = async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const response: any = await sendFetch(fetchLink.toString(), { method: 'GET' });
      console.log(response);
      if (response && response[0] === 200 && response[1].statusCode === 200) {
        setItemList(response[1].list);
      }
    };
    if (fetchLink) {
      fetchParams();
    } else {
      setItemList(mockList);
    }
  }, [fetchLink]);
  useEffect(()=> {
    let filteredList = locationList;
    if (searchValue) {
      filteredList = locationList.filter((itemToFilter: ParamCardProps) => {
        return itemToFilter.name.toLowerCase().includes(searchValue.toLowerCase());
      });
    }
    setSearchedList(filteredList);
  }, [searchValue, locationList]);
  return { itemList: locationList, searchedList };
};
